import { render, staticRenderFns } from "./WebhookSelectItem.vue?vue&type=template&id=1b208877&scoped=true&"
import script from "./WebhookSelectItem.vue?vue&type=script&lang=ts&"
export * from "./WebhookSelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./WebhookSelectItem.vue?vue&type=style&index=0&id=1b208877&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b208877",
  null
  
)

export default component.exports